const ELEMENT_CLASS = 'ui-float-label';
const FLOATING_CLASS = 'floating';

export function FloatLabelDirective() {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      fdFloatLabel: '='
    },
    link: function (scope, element) {
      let input = element.find('input') || element.find('select');
      let inputFocused;

      element.addClass(ELEMENT_CLASS);

      scope.$watch('fdFloatLabel', value => {
        if (inputFocused) {
          return;
        }
        if (value) {
          element.addClass(FLOATING_CLASS);
        } else {
          element.removeClass(FLOATING_CLASS);
        }
      });

      input.bind('focus', () => {
        inputFocused = true;
        element.addClass(FLOATING_CLASS);
      });

      input.bind('blur', () => {
        inputFocused = false;
        if (!scope.fdFloatLabel) {
          element.removeClass(FLOATING_CLASS);
        }
      });
    }
  };
}
